<template>
  <div class="wrapper" v-if="displayStructure">
    <va-header></va-header>
    <va-slider></va-slider>
    <div class="content-wrapper">
      <transition name="page" mode="out-in">
        <router-view/>
      </transition>
    </div>
  </div>
  <router-view v-else/>
</template>

<script>
import Header from './Header'
import Slider from './Slider'
import { mapState } from 'vuex'
import { fixLayout } from './helpers/adminlte'

// noinspection JSUnusedGlobalSymbols
export default {
  components: {
    'va-header': Header,
    'va-slider': Slider
  },
  computed: {
    ...mapState('user', [
      'logged'
    ]),
    ...mapState('lawFirms', {
      lawFirmSelected: 'selected'
    }),
    displayStructure () {
      return this.logged && this.lawFirmSelected !== null
    }
  },
  watch: {
    lawFirmSelected () {
      // Fix layout height after law firm selection
      this.$nextTick(fixLayout)
    }
  },
  mounted () {
    // Fix the layout height (for hot reload)
    fixLayout()
  }
}
</script>

<style lang="scss">
  @import './assets/scss/app.scss';

  .page-enter-active, .page-leave-active {
    transition: opacity 0.5s, transform 0.5s;
  }
  .page-enter, .page-leave-to {
    opacity: 0;
  }
</style>
